import ShakeAnimation from './ShakeAnimation';

export default {
  name: 'Shake',
  props: {
    shakeConfig: Object,
    centerImageList: Array,
    // 2023
    animationType: String, // 动画专场标识
    isUseOpenVideo: Boolean // 是否低电量模式
  },
  components: {},
  data: function() {
    return {
      isShowClickGuide: false,
      isShakeAble: false,
      shakeCenterLogoImage: '',
      isIOS: false,
      isOtherAnimation: true
    };
  },
  computed: {
    shakeCenterLogoStyleObj() {
      return {
        backgroundImage: `url(${this.shakeCenterLogoImage || ''})`
      };
    }
  },
  methods: {
    // 显示点击指引
    showClickGuide() {
      this.isShowClickGuide = true;
    },

    // 随机变换开合图
    randomCenterLogoImage() {
      let listLength = this.centerImageList.length;
      if (listLength > 0) {
        this.shakeCenterLogoImage = this.centerImageList[Math.ceil(Math.random() * listLength) - 1];
      }
    },

    // 监测页面是否可见变化
    addVisibilityListener() {
      let visibilityChange = '';

      if (typeof document.hidden !== 'undefined') {
        visibilityChange = 'visibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        visibilityChange = 'webkitvisibilitychange';
      }

      if (/(Android)/i.test(navigator.userAgent)) {
        //安卓处理
        //不支持原生
        WXGAME.WxBridge &&
          WXGAME.WxBridge.on('activity:state_change', (res) => {
            console.log('android visibility change');

            if (res.state === 'onResume') {
              this.onShow();
            } else {
              this.onHide();
            }
          });
      } else {
        //iOS处理
        document.addEventListener(
          visibilityChange,
          () => {
            console.log('iOS visibility change', document.hidden);
            if (document.hidden) {
              this.onHide();
            } else {
              this.onShow();
            }
          },
          false
        );
      }
    },

    // 页面可见时，恢复可摇状态
    onShow() {
      this.isPageShow = true;
      this.enableShake();

      // 上传到主页面
      this.$emit('page-show');
    },
    onHide() {
      this.isPageShow = false;
      this.$emit('page-hide');
    },

    enableShake() {
      this.isShakeAble = true;
      this.lastMoveTime = Date.now();
    },

    recoverGuide() {
      // 恢复前台状态
      ShakeAnimation.recover('.shake__main').then((res) => {
        this.isOtherAnimation = true;
      });
    },

    // 监测是否摇动
    shakeDetect(e) {
      let acceleration = e.accelerationIncludingGravity;
      let curTime = new Date().getTime();
      if (curTime - this.lastUpdate > 50) {
        let diffTime = curTime - this.lastUpdate;
        this.lastUpdate = curTime;
        this.x = acceleration.x;
        this.y = acceleration.y;
        this.z = acceleration.z;
        let speed =
          (Math.abs(this.x + this.y + this.z - this.lastX - this.lastY - this.lastZ) / diffTime) *
          10000;
        if (speed > this.SHAKETHRESHOLD) {
          this.doShake();
        }
      }
      this.lastX = this.x;
      this.lastY = this.y;
      this.lastZ = this.z;
    },

    //执行摇一摇动作
    doShake() {
      if (this.isShakeAble) {
        if (this.guideAnime) {
          this.guideAnime.pause();
          this.guideAnime.seek(0);
        }
        ShakeAnimation.action('.shake__main', 85, 600, 'easeInCubic').then(() => {
          this.sendShakeRequest();
        });

        this.isShakeAble = false;
        this.isOtherAnimation = false;
        // 变化开合图
        this.randomCenterLogoImage();

        this.$emit('ready-for-shake');
      }
    },

    // 发送摇一摇请求（外传事件）
    sendShakeRequest() {
      this.$emit('shake');
      console.log('shake');
    },

    // 移动时间响应
    motionHandler(e) {
      //监控点之间需要有时间间隔
      let nowTime = Date.now();
      if (nowTime - this.lastMoveTime >= this.shakeDuration && this.isPageShow) {
        this.shakeDetect(e);
      }
    },

    // 不支持时候的
    // 点击也可参与，兼容方案
    // 点击之后，不再显示guide
    shakeDowngradeHandler() {
      this.doShake();
      this.isShowClickGuide = false;
    },

    // 2023 修改
    // 整体缩放动画层
    scaleFitAnimationBox() {
      let targetEle = document.querySelector('.shake__animation');
      if (targetEle) {
        let screenWidth = document.body.clientWidth;
        let screenHeight = document.body.clientHeight;
        let screenScale = screenWidth / screenHeight;
        let bgWidth = 1292;
        let bgHeight = 1616;
        let bgScale = bgWidth / bgHeight;
        if (screenScale > bgScale) {
          targetEle.style.transform = `scale(${((screenWidth * 2) / bgWidth) *
            (414 / screenWidth)})`;
        } else {
          targetEle.style.transform = `scale(${((screenHeight * 2) / bgHeight) *
            (414 / screenWidth)})`;
        }
      }
    }
  },
  mounted: function() {
    this.SHAKETHRESHOLD = 2000;
    this.lastUpdate = 0;
    this.lastX = 0;
    this.lastY = 0;
    this.lastZ = 0;

    this.addVisibilityListener();

    this.isPageShow = true;
    this.isShakeAble = true;

    //初始参数
    this.lastMotion = [0, 0, 0];
    this.LIMIT = 1;
    this.COUNT_DOWN = 4;
    this.lastMoveTime = Date.now();
    this.shakeDuration = 1000;

    // 判断授权情况
    if (typeof DeviceMotionEvent.requestPermission === 'function') {
      DeviceMotionEvent.requestPermission()
        .then((response) => {
          // 如果是denied，就显示点击指引
          if (response === 'denied') {
            this.showClickGuide();
          }
        })
        .catch(() => {
          this.showClickGuide();
        });
    }

    // 返回设备系统信息
    this.isIOS = !WXGAME.Env.isAndroid;

    // 缩放屏幕
    this.scaleFitAnimationBox();
  }
};
